import React from "react";
import {css} from "@emotion/css";
import icExcel from "../../assets/images/svg/microsoft-excel.svg"
import icPdf from "../../assets/images/svg/pdf.svg"

const ReportItems = ({title, downloadPdf, downloadExcel}) => {
    return (
        <div className={css`
          border: 1px solid rgba(0, 0, 0, 0.2);
          border-radius: 15px;
          padding: 32px 16px;
          display: flex;
          flex-direction: row;
          justify-content: center;
          align-items: center;
          width: 100%;
          gap: 16px;

          @media screen and (max-width: 425px) {
            flex-direction: column;
          }


          img {
            height: 32px;
            cursor: pointer;
            object-fit: contain;
            transition: all 300ms linear;

            &:hover {
              transform: scale(1.1);
            }
          }
        `}>
            <span className={css`flex-grow: 1;`}>{title}</span>
            <div className={css`
              display: flex;
              flex-direction: row;
              justify-content: center;
              align-items: center;
              gap: 16px;
            `}>
                <img
                    className={css``}
                    src={icExcel}
                    alt={"ic_excel"}
                    onClick={downloadExcel}/>

                <img
                    className={css``}
                    src={icPdf}
                    alt={"ic_pdf"}
                    onClick={downloadPdf}/>
            </div>
        </div>
    )
}


export default ReportItems

export const ReportsItemTypes = {
    PDF: {
        id: "PDF",
        type: "pdf"
    },
    XLSX: {
        id: "XLSX",
        type: "xlsx"
    },
}